import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router-dom';
import { useAccess } from '@/warehouse/hooks';
const ProtectedRoute = ({ claims, groups, redirectPath = '/access', children }) => {
    const { userHasAccessTo } = useAccess();
    if (userHasAccessTo({ claims, groups })) {
        return children ? children : _jsx(Outlet, {});
    }
    return _jsx(Navigate, { to: redirectPath, replace: true });
};
export { ProtectedRoute };
